import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon fs-xs ap-icon-arrow-lg-left" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon fs-xs ap-icon-arrow-lg-right" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon fs-xs ap-icon-arrow-lg-top" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon fs-xs ap-icon-arrow-lg-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-calendar" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-calendar p-1 mx-1" }, null, -1)
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createBlock(_component_Datepicker, _mergeProps({ ..._ctx.$props, ..._ctx.$attrs }, { dayNames: _ctx.dayNames }), _createSlots({
    "arrow-left": _withCtx(() => [
      _hoisted_1
    ]),
    "arrow-right": _withCtx(() => [
      _hoisted_2
    ]),
    "arrow-up": _withCtx(() => [
      _hoisted_3
    ]),
    "arrow-down": _withCtx(() => [
      _hoisted_4
    ]),
    "calendar-icon": _withCtx(() => [
      _hoisted_5
    ]),
    "input-icon": _withCtx(() => [
      _hoisted_6
    ]),
    "clear-icon": _withCtx(({ clear }) => [
      _createElementVNode("i", {
        class: "ap-icon fs-small ap-icon-x p-1 mx-1",
        onClick: _withModifiers(clear, ["stop","prevent"])
      }, null, 8, _hoisted_7)
    ]),
    _: 2
  }, [
    _renderList(_ctx.allSlots, (slot, i) => {
      return {
        name: slot,
        fn: _withCtx((args) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(args)))
        ])
      }
    })
  ]), 1040, ["dayNames"]))
}